import React, {useEffect, useState} from 'react';

interface Pick11CountdownProps {
  startTime?: number;
  endTime?: number;
}

const Pick11Countdown = ({startTime, endTime}: Pick11CountdownProps) => {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!startTime && !endTime) {
      setText('');
      return;
    }

    const tick = () => {
      const now = Date.now();
      const start = startTime ? new Date(startTime).getTime() : null;
      const end = endTime ? new Date(endTime).getTime() : null;

      let target: number | null = null;
      if (start != null && end != null) {
        if (now < start) {
          target = start;
        } else if (now < end) {
          target = end;
        }
      } else if (start != null && now < start) {
        target = start;
      } else if (end != null && now < end) {
        target = end;
      }

      if (target == null) {
        setText('');
        return;
      }

      const diff = target - now;
      if (diff <= 0) {
        setText('');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (hours > 0) {
        setText(`${hours}h : ${minutes}m`);
        return;
      }

      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setText(`${minutes}m : ${seconds}s`);
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [endTime, startTime]);

  if (!text) {
    return null;
  }

  return <span className="text-sm font-bold text-[#FF2156]">{text}</span>;
};

export default Pick11Countdown;
